__turbopack_context__.v({
  "banner": "B382Gq_banner",
  "listItem": "B382Gq_listItem",
  "loaderWrapper": "B382Gq_loaderWrapper",
  "productGrid": "B382Gq_productGrid",
});
